import IMenuItem from "../../../../../model/interface/ui/IMenuItem";
import React from "react";
import MenuItemLink from "./MenuItemLink";

const MenuGroupBuilder = {
    buildChildren: (items: IMenuItem[], parent: string | null, onClick: (item: IMenuItem, parent?: boolean) => void) => {
        const roots = parent ? items.filter(value => value.parent && value.parent === parent)
            : items.filter(value => !value.parent)
        return roots
            .sort((a, b) => a.weight > b.weight ? 1 : -1)
            .map((item) => {
                    return <MenuItemLink items={items} key={item.uuid} item={item} onItemCLick={onClick}/>
                }
            )
    }
}

export default MenuGroupBuilder